<template>
  <li>
    <a :href="href" target="_blank">{{ text }}</a>
  </li>
</template>

<script>
export default {
  name: 'Footer_LinkListItem',
  props: {
    href: String,
    text: String
  }
}
</script>
